import { config } from './config.ts';

export type authProps = {
  authURL: string;
  redirect: string;
  backEndURL: string;
  clientId: string;
  webSocket: string;
};

export type apiConfigType = {
  local: authProps;
  dev: authProps;
  int: authProps;
  prod: authProps;
  backEndURL: string;
};

const {
  VITE_AUTHORITY,
  VITE_REDIRECT_URI,
  VITE_BACKEND_URL,
  VITE_CLIENT_ID,
  VITE_WEBSOCKET
} = config;

export const apiConfig: apiConfigType = {
  local: {
    authURL: VITE_AUTHORITY,
    redirect: VITE_REDIRECT_URI,
    clientId: VITE_CLIENT_ID,
    backEndURL: VITE_BACKEND_URL,
    webSocket: VITE_WEBSOCKET
  },
  dev: {
    authURL: VITE_AUTHORITY,
    redirect: VITE_REDIRECT_URI,
    clientId: VITE_CLIENT_ID,
    backEndURL: VITE_BACKEND_URL,
    webSocket: VITE_WEBSOCKET
  },
  int: {
    authURL: VITE_AUTHORITY,
    redirect: VITE_REDIRECT_URI,
    clientId: VITE_CLIENT_ID,
    backEndURL: VITE_BACKEND_URL,
    webSocket: VITE_WEBSOCKET
  },
  prod: {
    authURL: VITE_AUTHORITY,
    redirect: VITE_REDIRECT_URI,
    clientId: VITE_CLIENT_ID,
    backEndURL: VITE_BACKEND_URL,
    webSocket: VITE_WEBSOCKET
  },
  backEndURL: VITE_BACKEND_URL
};
